module.exports = __webpack_public_path__ + "static/Deforest-Party-Contract_2024-10-c0d79f24364681f00824959b4bc3bb1b.pdf";